var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRedBroadcast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 47.5C43.2467 47.5 47.5 43.2467 47.5 38C47.5 32.7533 43.2467 28.5 38 28.5C32.7533 28.5 28.5 32.7533 28.5 38C28.5 43.2467 32.7533 47.5 38 47.5Z",
    stroke: "#DC3545",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8853 53.1149C20.8983 51.1312 19.3219 48.7753 18.2464 46.1818C17.1708 43.5883 16.6172 40.8081 16.6172 38.0005C16.6172 35.1928 17.1708 32.4126 18.2464 29.8192C19.3219 27.2257 20.8983 24.8697 22.8853 22.886",
    stroke: "#DC3545",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1143 22.886C55.1013 24.8697 56.6777 27.2257 57.7532 29.8192C58.8288 32.4126 59.3824 35.1928 59.3824 38.0005C59.3824 40.8081 58.8288 43.5883 57.7532 46.1818C56.6777 48.7753 55.1013 51.1312 53.1143 53.1149",
    stroke: "#DC3545",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4887 61.5113C11.3978 58.4257 8.94565 54.7608 7.27256 50.7265C5.59947 46.6922 4.73828 42.3675 4.73828 38C4.73828 33.6325 5.59947 29.3079 7.27256 25.2735C8.94565 21.2392 11.3978 17.5744 14.4887 14.4887",
    stroke: "#DC3545",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5117 14.4887C64.6026 17.5744 67.0548 21.2392 68.7279 25.2735C70.401 29.3079 71.2622 33.6325 71.2622 38C71.2622 42.3675 70.401 46.6922 68.7279 50.7265C67.0548 54.7608 64.6026 58.4257 61.5117 61.5113",
    stroke: "#DC3545",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBroadcast);
export default __webpack_public_path__ + "static/media/red-broadcast.b5b7d1a414b56fca35effe5d49fae881.svg";
export { ForwardRef as ReactComponent };